<template>
  <el-dialog
    title="升级"
    :visible.sync="dialogVisible"
    customClass="customWidth"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="mini"
    >
      <el-form-item
        prop="legal"
        label="代理名称"
      >
        {{userName}}
      </el-form-item>
      <el-form-item
        prop="userName"
        label="原上级代理"
      >
        {{sjName}}
      </el-form-item>
      <el-form-item
        prop="prov_cd"
        label="修改为"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                filterable
                v-model="form.prov_cd"
                placeholder="请选择"
                class="search-input"
                :filter-method="dataFilter"
        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.agentid"
                  :label="item.agentname"
                  :value="item.agentid"
          ></el-option>
        </el-select>
      </el-form-item>




    <el-form-item>
      <el-button
              type="primary"
              :loading="loading"
              @click="saveUser"
      >保存</el-button>
      <el-button @click="close">取消</el-button>
    </el-form-item>
    </el-form>
  </el-dialog>

</template>
<style>
  .customWidth{
    width:80%;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js';
export default {
  name: "twoagentyEditForm",
  props: {
      oneagent: Object,
    value: Boolean
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
        userName:"",
        sjName:"",
      form: {
          prov_cd:""
      },
        typeOptions: [],
        optionsCopy: []
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
      dataFilter(val) {
          if (val) { //val存在
              this.typeOptions = this.optionsCopy.filter((item) => {
                  if (!!~item.agentname.indexOf(val) || !!~item.agentname.toUpperCase().indexOf(val.toUpperCase())) {
                      return true
                  }
              })
          } else { //val为空时，还原数组
              this.typeOptions = this.optionsCopy;
          }
      },
    dialogOpen() {
      this.$refs.form.resetFields();
        var formData2 = new FormData() // 声明一个FormData对象
        formData2.append('agentid',util.cookies.get('agentid'));
        formData2.append('dl_type',"0");
        formData2.append('dl_type2',util.cookies.get('dl_type'));
        formData2.append('xt_id',util.cookies.get('xt_id'));
        agentService.getOneagent(formData2).then(data => {
            this.typeOptions=data;
            this.optionsCopy=data;
        });
      if (this.oneagent.userId) {

          this.userName = this.oneagent.userName;
          this.sjName=this.oneagent.pagentid;
      } else {
        this.form = {};
      }

    },
      saveUser() {
          this.$refs["form"].validate(valid => {
              if (valid) {
                  if (this.oneagent.userId) {
                      this.loading = true;
                      agentService.savePagentid({ ...this.form,userId:this.oneagent.userId ,agentid:this.oneagent.agentid})
                          .then(data => {
                              this.loading = false;
                              this.dialogVisible = false;
                              this.$emit("submit");
                          });
                  }
              } else {
                  return false;
              }
          });
      },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

